import createReducer from '../createReducer';
import {TAiAgent} from './aiAgent.type';

const initialState: TAiAgent = {
    isOpen: false,
    meta: null,
    metaPid: null,
    metaXHR: null,
    sessionEventType: null,
    sessionIntent: null,
    chatLang: null,
    pendingTicketTid: null,
    currentFormValues: null,
    pendingProposal: null,
    pendingProposalOwner: null,
    createdDraftFields: null,
    createdDraftEid: null,
    activeFormId: null,
    sendMessageXHR: null,
    executeProposalXHR: null,
};

export default createReducer('aiAgent', initialState);
